import { useMemo } from 'react';
import { isApp, isKronWebApp } from '../../utils';
import {
  isKronWebView,
  webviewToNative,
} from '@storebrand-digital/kron-web-view-helpers';

export interface Insets {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export const useKron = () => {
  const isKron = useMemo(() => isKronWebView || isKronWebApp || isApp, []);
  const insets: Insets = (isKronWebView &&
    window.nativeToWebviewData?.extraProps?.insets) || {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  };

  const closeWebView = (withConfirmation: boolean = true) => {
    if (isKronWebView) {
      webviewToNative.postMessage({
        type: 'closeWebview',
        withConfirmation: withConfirmation,
      });
    }
  };

  const openPdfUrl = (url: string, downloadFilename: string) => {
    if (isKronWebView) {
      webviewToNative.postMessage({
        type: 'openPdfUrl',
        url,
        downloadFilename,
      });
    }
  };

  const showPdf = (
    downloadFilename: string,
    source: { type: 'url'; url: string } | { type: 'base64'; data: string }
  ) => {
    if (isKronWebView) {
      webviewToNative.postMessage({
        type: 'showPdf',
        downloadFilename,
        source,
      });
    }
  };

  const openPdf = (pdfData: string) => {
    if (isKronWebView) {
      webviewToNative.postMessage({
        type: 'openPdf',
        pdfData,
      });
    }
  };

  return {
    isKron,
    insets,
    closeWebView,
    openPdfUrl,
    openPdf,
    showPdf,
  };
};
